<template>
  <div class="py-4 px-3">
    <!-- display current measurements group and create add new button -->
    <v-layout row wrap>
      <v-flex v-for="measurement in measurements" :key="measurement.id" class="mx-2" xs12 sm6 md4 lg3>
        <v-card :to="`/measurements/${measurement.id}`">

          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{measurement.name}}</h3>
            </div>
          </v-card-title>

        </v-card>
      </v-flex>
       <v-flex class="mx-2" xs12 sm6 md4 lg3>
        <v-card to="/measurements/newmeasurementgroup">

          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Add new measurement group</h3>
              <div>Here you can add new measurement group that, that you later need to select in suit info.</div>
            </div>
          </v-card-title>

        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  db
} from '../firebase';
export default {
  data(){
    return {
      measurements:[]
    }
  },
  methods:{
      getMeasurements() {
      let result = [];
      db.collection("measurements")
        .get()
        .then(items => {
          items.forEach(category => {
            let categoryData = category.data();
            categoryData.id = category.id;
            result.push(categoryData);
          });
        })
        .catch(e => {
          console.error(`Error happended: ${e}`);
        });
      this.measurements = result;
    }
  },
  created() {
    // make call to db and get all measurements group
    this.getMeasurements();
  }
};
</script>

<style>
</style>
